import { ReviewDetailsBase } from "./ReviewDetailsBase";

export class ReviewDetails extends ReviewDetailsBase {
    request: string = '';
    requestor: string = '';
    requestorBsetUserId: string = '';
    reviewer: string = '';
    openDate: Date | string = new Date();
    closeDate: Date | string = new Date();
    requiredBy: Date | string = new Date();
    segment: string = '';
    subSegment: string = '';
    originalReviewer: string = '';
}